import React, { ChangeEvent, FC } from 'react';
import styled from 'styled-components';
import { Black, Grey, White } from '../../../styles/colours';
import { Regular } from '../../../styles/fonts';

interface IFormProps {
  onSubmit: (e: ChangeEvent<HTMLFormElement>) => void;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  alternativePlants?: string[];
}

const StyledSelect = styled.select`
  font-family: ${Regular};
  background: ${White};
  color: ${Black};
  border: 1px solid ${Grey};
  border-radius: 4px;
  width: 12rem;
  padding: 0.5rem 0rem 0.5rem 0.5rem;
`;

export const StyledForm = styled.form`
  margin-left: 0.3rem;
`;

const PlantForm: FC<IFormProps> = ({
  onSubmit,
  onChange,
  alternativePlants,
}) => {
  return (
    <StyledForm onSubmit={onSubmit}>
      <StyledSelect onChange={onChange}>
        <option value={-1}> Select Plant... </option>
        {alternativePlants?.map((plant, index) => (
          <option key={index}>{plant}</option>
        ))}
      </StyledSelect>
    </StyledForm>
  );
};

export { PlantForm };
